<template>
	<ion-page :class="class">
		<ion-header v-show="!loading && !hideHeader">
			<ion-toolbar>
				<ion-title>{{ pageTitle }}</ion-title>
				<ion-buttons slot="start">
					<ion-button v-if="(!hideBackLink && (routerCanGoBack || pageDefaultBackLink)) || (!hideBackLink && overridePageBackLink)" @click="backButtonClicked">
						<ion-icon slot="icon-only" icon="/assets/custom-icons/014-arrow-left.svg"></ion-icon>
					</ion-button>
					<slot name="buttonsStart"></slot>
				</ion-buttons>
				<ion-buttons slot="end">
					<slot name="buttonsEnd"></slot>
				</ion-buttons>
			</ion-toolbar>
			<slot name="afterToolbar"></slot>
		</ion-header>
		<ion-content ref="contentElement" v-show="!loading" :fullscreen="true" :color="contentColor">
			<slot />
		</ion-content>
		<div class="loading-screen" v-show="loading"></div>
	</ion-page>
</template>

<script setup>
import { IonPage, IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, IonTitle, IonContent, useIonRouter } from "@ionic/vue"
import { ref, computed } from "vue"

const ionRouter = useIonRouter()

const props = defineProps({
	pageTitle: String,
	pageDefaultBackLink: String,
	overridePageBackLink: String,
	class: String,
	hideBackLink: Boolean,
	hideHeader: Boolean,
	loading: Boolean,
	contentColor: String,
})

const contentElement = ref(null)
const routerCanGoBack = computed(() => ionRouter.canGoBack())

defineExpose({
	contentElement,
})

const backButtonClicked = () => {
	if (props.overridePageBackLink) {
		ionRouter.navigate(props.overridePageBackLink, "back", "pop")
	} else if (ionRouter.canGoBack()) {
		// checked now, routerCanGoBack is not updated (canGoBack() is not reactive)
		ionRouter.back()
	} else if (props.pageDefaultBackLink) {
		ionRouter.navigate(props.pageDefaultBackLink, "back", "pop")
	} else {
		console.warn("⬅️ unknown back target")
	}
}
</script>

<style scoped>
.loading-screen {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 99999;
	width: 100vw;
	height: 100vh;
	background: url("/assets/loading_screen.png") no-repeat center center / cover;
}
</style>
